import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { sizeOptions } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import Select from 'react-select'
import PropTypes from 'prop-types'
import Switch from 'react-switch'

const DryBeansPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    BeanPeaLentilSize: item.BeanPeaLentilSize,
    Organic: item.Organic,
  })
  const methods = useFormContext()
  const { setSelectReviewer, setSwitchReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { BeanPeaLentilSize, Organic } = item
      setPackaging({
        BeanPeaLentilSize,
        Organic,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={6}>
          <FormGroup>
            <h6>Size {asterisk}</h6>
            <Controller
              as={Select}
              className="react-select primary"
              classNamePrefix="react-select"
              options={sizeOptions}
              defaultValue={{
                label: packaging.BeanPeaLentilSize,
                value: packaging.BeanPeaLentilSize,
              }}
              name="BeanPeaLentilSize"
              control={methods.control}
              rules={{ required: true }}
              placeholder={'Select Size'}
              onChange={([selected, value]) => {
                setSelectReviewer(item, selected, value)
                return selected
              }}
              isDisabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="BeanPeaLentilSize"
                message={'⚠ Bean size is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={6}>
          <p>
            <strong>Organic</strong>
          </p>
          <Controller
            as={Switch}
            name="Organic"
            id="Organic"
            defaultValue={packaging.Organic}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            checked={packaging.Organic}
            disabled={isDisabled}
          />
        </Col>
      </Row>
    </>
  )
}

DryBeansPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default DryBeansPackageReview
